import React from "react";
import resume from "./../../docs/CV_Siegfred.pdf";

const CTA = () => {
  return (
    <div className="cta">
      <a href={resume} download className="btn">
        Download CV
      </a>
      <a href="#contact" className="btn btn-primary">
        Say Hello
      </a>
    </div>
  );
};

export default CTA;
